import React, { useState, useEffect, useRef } from 'react';
import { supabase } from '../supabaseClient'; 
import SearchBar from '../components/SearchBar';

const LISTINGS = [
  { id: 1, title: 'Villa provencale avec piscine', location: 'Nice · Colline de Cimiez', region: 'Cote d\'Azur', type: 'Villa', category: 'mer', guests: 4, beds: 3, baths: 2, amenities: ['Piscine', 'Parking', 'Climatisation', 'Vue mer'], priceNight: 320, rating: 4.97, reviews: 8, img: 'https://images.pexels.com/photos/28652349/pexels-photo-28652349.jpeg?auto=compress&cs=tinysrgb&w=600', isExample: true, latitude: 43.7102, longitude: 7.2620 },
  { id: 2, title: 'Maison avec vue panoramique sur la mer', location: 'Eze · Village medieval', region: 'Cote d\'Azur', type: 'Maison', category: 'mer', guests: 5, beds: 3, baths: 2, amenities: ['Vue mer', 'Piscine', 'Climatisation'], priceNight: 480, rating: 5.0, reviews: 4, img: 'https://images.pexels.com/photos/7587480/pexels-photo-7587480.jpeg?auto=compress&cs=tinysrgb&w=600', isExample: true, latitude: 43.7275, longitude: 7.3617 },
  { id: 3, title: 'Appartement lumineux terrasse vue mer', location: 'Cannes · La Croisette', region: 'Cote d\'Azur', type: 'Appartement', category: 'mer', guests: 3, beds: 2, baths: 1, amenities: ['Vue mer', 'Terrasse', 'WiFi', 'Climatisation'], priceNight: 210, rating: 4.91, reviews: 11, img: 'https://images.pexels.com/photos/19846383/pexels-photo-19846383.jpeg?auto=compress&cs=tinysrgb&w=600', isExample: true, latitude: 43.5528, longitude: 7.0174 },
  { id: 4, title: 'Bastide provencale avec oliveraie', location: 'Gordes · Luberon', region: 'Provence', type: 'Villa', category: 'campagne', guests: 8, beds: 5, baths: 4, amenities: ['Piscine', 'Jardin', 'Barbecue', 'Parking'], priceNight: 395, rating: 4.94, reviews: 6, img: 'https://images.pexels.com/photos/24205634/pexels-photo-24205634.jpeg?auto=compress&cs=tinysrgb&w=600', isExample: true, latitude: 43.9117, longitude: 5.1983 },
  { id: 5, title: 'Mas en pierre avec piscine naturelle', location: 'Les Baux · Provence', region: 'Provence', type: 'Maison', category: 'campagne', guests: 6, beds: 4, baths: 2, amenities: ['Piscine', 'Jardin', 'Climatisation', 'WiFi'], priceNight: 275, rating: 4.89, reviews: 9, img: 'https://images.pexels.com/photos/34688219/pexels-photo-34688219.jpeg?auto=compress&cs=tinysrgb&w=600', isExample: true, latitude: 43.7442, longitude: 4.7958 },
  { id: 6, title: 'Domaine viticole avec cave privee', location: 'Saint-Remy · Alpilles', region: 'Provence', type: 'Villa', category: 'campagne', guests: 6, beds: 4, baths: 3, amenities: ['Piscine', 'Cave', 'Jardin', 'Parking'], priceNight: 340, rating: 4.96, reviews: 5, img: 'https://images.pexels.com/photos/26925314/pexels-photo-26925314.jpeg?auto=compress&cs=tinysrgb&w=600', isExample: true, latitude: 43.7892, longitude: 4.8317 },
  { id: 7, title: 'Villa basque avec vue sur l\'ocean', location: 'Biarritz · Cote des Basques', region: 'Pays Basque', type: 'Villa', category: 'mer', guests: 6, beds: 4, baths: 3, amenities: ['Vue mer', 'Piscine', 'Terrasse', 'Parking'], priceNight: 290, rating: 4.93, reviews: 12, img: 'https://images.pexels.com/photos/30211366/pexels-photo-30211366.jpeg?auto=compress&cs=tinysrgb&w=600', isExample: true, latitude: 43.4832, longitude: -1.5586 },
  { id: 8, title: 'Maison basque typique avec jardin', location: 'Saint-Jean-de-Luz · Centre', region: 'Pays Basque', type: 'Maison', category: 'mer', guests: 4, beds: 3, baths: 2, amenities: ['Jardin', 'WiFi', 'Parking', 'Lave-linge'], priceNight: 185, rating: 4.88, reviews: 14, img: 'https://images.pexels.com/photos/7511695/pexels-photo-7511695.jpeg?auto=compress&cs=tinysrgb&w=600', isExample: true, latitude: 43.3896, longitude: -1.6620 },
  { id: 9, title: 'Maison de plage acces direct ocean', location: 'Hossegor · Les Landes', region: 'Pays Basque', type: 'Maison', category: 'mer', guests: 5, beds: 3, baths: 2, amenities: ['Vue mer', 'Terrasse', 'Barbecue', 'WiFi'], priceNight: 220, rating: 4.85, reviews: 7, img: 'https://images.pexels.com/photos/36025790/pexels-photo-36025790.jpeg?auto=compress&cs=tinysrgb&w=600', isExample: true, latitude: 43.6661, longitude: -1.4068 },
  { id: 10, title: 'Villa avec piscine face a la mer', location: 'Porto-Vecchio · Corse du Sud', region: 'Corse', type: 'Villa', category: 'mer', guests: 8, beds: 5, baths: 3, amenities: ['Piscine', 'Vue mer', 'Climatisation', 'Parking'], priceNight: 520, rating: 4.98, reviews: 5, img: 'https://images.pexels.com/photos/28652349/pexels-photo-28652349.jpeg?auto=compress&cs=tinysrgb&w=600', isExample: true, latitude: 41.5908, longitude: 9.2798 },
  { id: 11, title: 'Bergerie corse avec jardin fleuri', location: 'Propriano · Corse', region: 'Corse', type: 'Maison', category: 'campagne', guests: 4, beds: 3, baths: 2, amenities: ['Jardin', 'Terrasse', 'WiFi', 'Parking'], priceNight: 310, rating: 4.92, reviews: 8, img: 'https://images.pexels.com/photos/19857234/pexels-photo-19857234.jpeg?auto=compress&cs=tinysrgb&w=600', isExample: true, latitude: 41.6803, longitude: 8.9003 },
  { id: 12, title: 'Villa pieds dans l\'eau en Corse', location: 'Calvi · Haute-Corse', region: 'Corse', type: 'Villa', category: 'mer', guests: 6, beds: 4, baths: 3, amenities: ['Vue mer', 'Piscine', 'Terrasse', 'Climatisation'], priceNight: 440, rating: 4.95, reviews: 3, img: 'https://images.pexels.com/photos/7587480/pexels-photo-7587480.jpeg?auto=compress&cs=tinysrgb&w=600', isExample: true, latitude: 42.5667, longitude: 8.7575 },
];

const TRANSPARENCY_SCORES = { 1:{score:97},2:{score:89},3:{score:91},4:{score:94},5:{score:88},6:{score:96},7:{score:93},8:{score:85},9:{score:87},10:{score:98},11:{score:92},12:{score:95} };

const NEARBY = {
  'nice':['Cannes','Eze','Antibes','Monaco','Cote d\'Azur'],
  'cannes':['Nice','Antibes','Eze','Cote d\'Azur'],
  'biarritz':['Saint-Jean-de-Luz','Hossegor','Bayonne','Pays Basque'],
  'hossegor':['Biarritz','Saint-Jean-de-Luz','Pays Basque'],
  'gordes':['Luberon','Provence','Avignon','Les Baux'],
  'porto-vecchio':['Propriano','Calvi','Bonifacio','Corse'],
  'propriano':['Porto-Vecchio','Ajaccio','Corse'],
  'calvi':['Porto-Vecchio','Ajaccio','Corse'],
};

const CATEGORIES = [
  { id: 'mer',      label: '🏖️ Mer'      },
  { id: 'montagne', label: '⛷️ Montagne' },
  { id: 'campagne', label: '🌿 Campagne' },
  { id: 'ville',    label: '🏙️ Ville'    },
  { id: 'lac',      label: '🏞️ Lac'      },
  { id: 'luxe',     label: '✨ Luxe'     },
];

const getScoreColor = s => s >= 90 ? { color: '#0F6E56', bg: '#E8F5F0' } : s >= 75 ? { color: '#C4784A', bg: '#FDF0E6' } : { color: '#A32D2D', bg: '#FCEBEB' };
const FILTERS = ['Tout', 'Villa', 'Appartement', 'Maison'];
const AMENITY_OPTIONS = ['Piscine', 'Vue mer', 'Parking', 'WiFi', 'Jardin', 'Climatisation'];

// ── Composant carte Leaflet ──────────────────────────────────────────────────
function MapView({ listings, onSelectListing, selectedId }) {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const markersRef = useRef([]);

  useEffect(() => {
    // Charger Leaflet dynamiquement
    if (!window.L) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      document.head.appendChild(link);

      const script = document.createElement('script');
      script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
      script.onload = () => initMap();
      document.head.appendChild(script);
    } else {
      initMap();
    }

    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove();
        mapInstanceRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (mapInstanceRef.current && window.L) {
      updateMarkers();
    }
  }, [listings, selectedId]);

  const initMap = () => {
    if (!mapRef.current || mapInstanceRef.current) return;
    const L = window.L;

    const map = L.map(mapRef.current, {
  center: [46.5, 2.5],
  zoom: 5,
  zoomControl: false,
});

    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
      attribution: '© OpenStreetMap © CARTO',
      subdomains: 'abcd',
      maxZoom: 19,
    }).addTo(map);

    // Abaisser le z-index des controles Leaflet
const style = document.createElement('style');
style.textContent = '.leaflet-control-container { display: none !important; }';
document.head.appendChild(style);

    mapInstanceRef.current = map;
    updateMarkers();
  };

  const updateMarkers = () => {
    const L = window.L;
    if (!L || !mapInstanceRef.current) return;

    // Supprimer anciens marqueurs
    markersRef.current.forEach(m => m.remove());
    markersRef.current = [];

    const validListings = listings.filter(l => l.latitude && l.longitude);

    validListings.forEach(l => {
      const isSelected = l.id === selectedId;
      const isReal = l.isReal === true;

      const icon = L.divIcon({
        className: '',
        html: `<div style="
          background: ${isSelected ? '#0F1A16' : isReal ? '#1D9E75' : '#fff'};
          color: ${isSelected ? '#fff' : isReal ? '#fff' : '#0F1A16'};
          border: 2px solid ${isSelected ? '#0F1A16' : isReal ? '#1D9E75' : '#0F1A16'};
          border-radius: 20px;
          padding: 4px 10px;
          font-size: 12px;
          font-weight: 600;
          white-space: nowrap;
          box-shadow: 0 2px 8px rgba(0,0,0,0.15);
          font-family: -apple-system, sans-serif;
          cursor: pointer;
          transform: ${isSelected ? 'scale(1.1)' : 'scale(1)'};
          transition: transform 0.15s;
        ">${l.priceNight} €</div>`,
        iconAnchor: [30, 16],
      });

      const marker = L.marker([l.latitude, l.longitude], { icon })
        .addTo(mapInstanceRef.current)
        .on('click', () => onSelectListing(l));

      markersRef.current.push(marker);
    });

    // Ajuster la vue si des marqueurs existent
    if (validListings.length > 0 && !selectedId) {
      const bounds = L.latLngBounds(validListings.map(l => [l.latitude, l.longitude]));
      mapInstanceRef.current.fitBounds(bounds, { padding: [40, 40] });
    }
  };

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <div ref={mapRef} style={{ width: '100%', height: '100%', borderRadius: 12 }} />
<div style={{ position: 'absolute', top: 12, left: 12, zIndex: 1000, display: 'flex', flexDirection: 'column', gap: 4 }}>
  <button onClick={() => mapInstanceRef.current?.zoomIn()} style={{ width: 32, height: 32, background: '#fff', border: '1px solid var(--border)', borderRadius: 8, fontSize: 18, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 6px rgba(0,0,0,0.1)', fontFamily: 'var(--sans)' }}>+</button>
  <button onClick={() => mapInstanceRef.current?.zoomOut()} style={{ width: 32, height: 32, background: '#fff', border: '1px solid var(--border)', borderRadius: 8, fontSize: 18, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 6px rgba(0,0,0,0.1)', fontFamily: 'var(--sans)' }}>−</button>
</div>
    </div>
  );
}

// ── Mini-card popup sur la carte ─────────────────────────────────────────────
function MapPopup({ listing, onClose, onNavigate }) {
  if (!listing) return null;
  return (
    <div style={{
      position: 'absolute', bottom: 16, left: '50%', transform: 'translateX(-50%)',
      background: '#fff', borderRadius: 14, boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
      width: 280, zIndex: 1000, overflow: 'hidden',
    }}>
      <button onClick={onClose} style={{ position: 'absolute', top: 8, right: 8, background: 'rgba(0,0,0,0.5)', border: 'none', borderRadius: '50%', width: 24, height: 24, cursor: 'pointer', color: '#fff', fontSize: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1 }}>×</button>
      {listing.img && (
        <img src={listing.img} alt={listing.title} style={{ width: '100%', height: 130, objectFit: 'cover', display: 'block' }} />
      )}
      <div style={{ padding: '10px 12px' }}>
        <div style={{ fontSize: 11, color: 'var(--ink-4)', marginBottom: 2 }}>{listing.location}</div>
        <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 6, lineHeight: 1.3 }}>{listing.title}</div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ fontSize: 14, fontWeight: 600 }}>
            à partir de {listing.priceNight} € <span style={{ fontSize: 11, fontWeight: 400, color: 'var(--ink-3)' }}>/nuit</span>
          </div>
          {!listing.isExample && (
            <button onClick={() => { onNavigate('listing', listing); onClose(); }}
              style={{ padding: '6px 14px', background: 'var(--green)', color: '#fff', border: 'none', borderRadius: 20, fontSize: 12, fontWeight: 500, cursor: 'pointer', fontFamily: 'var(--sans)' }}>
              Voir →
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default function SearchPage({ onNavigate, searchFilter = '' }) {
  const savedGuests = JSON.parse(localStorage.getItem('havenly_search_guests') || '{"adults":1,"children":0}');
  const searchTotalGuests = savedGuests.adults + savedGuests.children;

  const [activeType,      setActiveType]      = useState('Tout');
  const [activeCategory,  setActiveCategory]  = useState('');
  const [sortBy,          setSortBy]          = useState('default');
  const [favorites,       setFavorites]       = useState([]);
  const [isMobile,        setIsMobile]        = useState(window.innerWidth < 768);
  const [filtersOpen,     setFiltersOpen]     = useState(false);
  const [priceMax,        setPriceMax]        = useState(600);
  const [minRating,       setMinRating]       = useState(0);
  const [activeAmenities, setActiveAmenities] = useState([]);
  const [realListings,    setRealListings]    = useState([]);
  const [realLoading,     setRealLoading]     = useState(true);
  const [showMap,         setShowMap]         = useState(!isMobile);
  const [selectedListing, setSelectedListing] = useState(null);
  const [mobileView,      setMobileView]      = useState('list'); // 'list' | 'map'

  useEffect(() => {
    const onResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setShowMap(true);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (!session) onNavigate('auth');
    });
  }, [onNavigate]);

  useEffect(() => {
    supabase
      .from('listings')
      .select('*')
      .in('status', ['active', 'published'])
      .then(({ data, error }) => {
        if (!error && data) {
          setRealListings(data.map(l => ({
            target_audience: l.target_audience || '',
            video_url: l.video_url || null,
            id: l.id,
            title: l.title,
            location: l.city || '',
            region: l.city || '',
            type: l.type || 'Villa',
            category: l.category || '',
            guests: l.guests_max || l.guests || 2,
            beds: l.bedrooms || 1,
            baths: l.bathrooms || 1,
            amenities: l.amenities || [],
            priceNight: l.price_night || 0,
            rating: 5.0,
            reviews: 0,
            img: l.photos?.[0] || '',
            isExample: false,
            isReal: true,
            score_transparency: l.score_transparency,
            dbId: l.id,
            description: l.description,
            photos: l.photos,
            city: l.city || '',
            latitude: l.latitude || null,
            longitude: l.longitude || null,
          })));
        }
        setRealLoading(false);
      });
  }, []);

  const toggleFav     = id => setFavorites(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  const toggleAmenity = a  => setActiveAmenities(prev => prev.includes(a) ? prev.filter(x => x !== a) : [...prev, a]);

  const activeFiltersCount = (activeType !== 'Tout' ? 1 : 0) + (activeCategory ? 1 : 0) + (priceMax < 600 ? 1 : 0) + (minRating > 0 ? 1 : 0) + activeAmenities.length + (searchTotalGuests > 1 ? 1 : 0);

  const savedLocation = (() => { try { return JSON.parse(localStorage.getItem('havenly_search_location') || 'null'); } catch(e) { return null; } })();
  const effectiveFilter = (savedLocation && savedLocation.cityName === searchFilter) ? savedLocation.cityName : searchFilter;

  const allListings = [...realListings, ...LISTINGS];

  let results = allListings.filter(l => {
    if (activeType !== 'Tout' && l.type !== activeType) return false;
    if (activeCategory && l.category !== activeCategory) return false;
    const listingCapacity = l.guests || l.guests_max || 99;
    if (searchTotalGuests > 1 && listingCapacity < searchTotalGuests) return false;
    if (l.priceNight > priceMax) return false;
    if (minRating > 0 && l.rating < minRating) return false;
    if (activeAmenities.length > 0 && !activeAmenities.every(a => l.amenities.includes(a))) return false;
    if (effectiveFilter && !l.location.toLowerCase().includes(effectiveFilter.toLowerCase()) && !l.title.toLowerCase().includes(effectiveFilter.toLowerCase()) && !l.region.toLowerCase().includes(effectiveFilter.toLowerCase()) && !(l.city || '').toLowerCase().includes(effectiveFilter.toLowerCase()) && !l.amenities.some(a => a.toLowerCase().includes(effectiveFilter.toLowerCase()))) return false;
    return true;
  });

  if (sortBy === 'price_asc') results = [...results].sort((a, b) => a.priceNight - b.priceNight);
  if (sortBy === 'rating')    results = [...results].sort((a, b) => b.rating - a.rating);

  const nearby = effectiveFilter ? NEARBY[effectiveFilter.toLowerCase()] : null;

  const FilterPanel = () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div>
        <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 10 }}>Type de logement</div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {FILTERS.map(f => (
            <button key={f} onClick={() => setActiveType(f)} style={{ padding: '6px 14px', borderRadius: 20, fontSize: 13, fontFamily: 'var(--sans)', cursor: 'pointer', border: `1px solid ${activeType === f ? 'var(--green)' : 'var(--border)'}`, background: activeType === f ? 'var(--green-light)' : 'var(--white)', color: activeType === f ? 'var(--green-mid)' : 'var(--ink-3)', fontWeight: activeType === f ? 500 : 400 }}>
              {f}
            </button>
          ))}
        </div>
      </div>
      <div>
        <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 10 }}>Environnement</div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {CATEGORIES.map(cat => (
            <button key={cat.id} onClick={() => setActiveCategory(c => c === cat.id ? '' : cat.id)}
              style={{ padding: '6px 14px', borderRadius: 20, fontSize: 13, fontFamily: 'var(--sans)', cursor: 'pointer', border: `1px solid ${activeCategory === cat.id ? 'var(--green)' : 'var(--border)'}`, background: activeCategory === cat.id ? 'var(--green-light)' : 'var(--white)', color: activeCategory === cat.id ? 'var(--green-mid)' : 'var(--ink-3)', fontWeight: activeCategory === cat.id ? 500 : 400 }}>
              {cat.label}
            </button>
          ))}
        </div>
      </div>
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
          <span style={{ fontSize: 13, fontWeight: 500 }}>Prix maximum / nuit</span>
          <span style={{ fontSize: 13, fontWeight: 500, color: 'var(--green-mid)' }}>{priceMax} €</span>
        </div>
        <input type="range" min={50} max={600} step={10} value={priceMax} onChange={e => setPriceMax(Number(e.target.value))} style={{ width: '100%', accentColor: 'var(--green)' }} />
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: 'var(--ink-4)', marginTop: 4 }}>
          <span>50 €</span><span>600 €</span>
        </div>
      </div>
      <div>
        <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 10 }}>Note minimale</div>
        <div style={{ display: 'flex', gap: 8 }}>
          {[0, 4.5, 4.8, 4.9].map(r => (
            <button key={r} onClick={() => setMinRating(r)} style={{ padding: '6px 14px', borderRadius: 20, fontSize: 12, fontFamily: 'var(--sans)', cursor: 'pointer', border: `1px solid ${minRating === r ? 'var(--green)' : 'var(--border)'}`, background: minRating === r ? 'var(--green-light)' : 'var(--white)', color: minRating === r ? 'var(--green-mid)' : 'var(--ink-3)', fontWeight: minRating === r ? 500 : 400 }}>
              {r === 0 ? 'Toutes' : `★ ${r}+`}
            </button>
          ))}
        </div>
      </div>
      <div>
        <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 10 }}>Équipements</div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {AMENITY_OPTIONS.map(a => (
            <button key={a} onClick={() => toggleAmenity(a)} style={{ padding: '6px 14px', borderRadius: 20, fontSize: 12, fontFamily: 'var(--sans)', cursor: 'pointer', border: `1px solid ${activeAmenities.includes(a) ? 'var(--green)' : 'var(--border)'}`, background: activeAmenities.includes(a) ? 'var(--green-light)' : 'var(--white)', color: activeAmenities.includes(a) ? 'var(--green-mid)' : 'var(--ink-3)', fontWeight: activeAmenities.includes(a) ? 500 : 400 }}>
              {a}
            </button>
          ))}
        </div>
      </div>
      {activeFiltersCount > 0 && (
        <button onClick={() => { setActiveType('Tout'); setActiveCategory(''); setPriceMax(600); setMinRating(0); setActiveAmenities([]); }}
          style={{ padding: '8px', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 8, fontSize: 13, color: 'var(--ink-3)', cursor: 'pointer', fontFamily: 'var(--sans)' }}>
          Réinitialiser les filtres
        </button>
      )}
    </div>
  );

  const ListingCard = ({ l }) => {
    const isFav  = favorites.includes(l.id);
    const score  = l.score_transparency || TRANSPARENCY_SCORES[l.id]?.score;
    const sc     = score ? getScoreColor(score) : null;
    const isReal = l.isReal === true;
    const isSelected = selectedListing?.id === l.id;

    return (
      <div
        onClick={() => { if (!l.isExample) onNavigate('listing', l); setSelectedListing(l); }}
        style={{
          background: 'var(--white)',
          border: isSelected ? '2px solid var(--green)' : isReal ? '1.5px solid #A7E3CD' : '0.5px solid var(--border)',
          borderRadius: 16, overflow: 'hidden',
          cursor: l.isExample ? 'default' : 'pointer',
          transition: 'box-shadow 0.2s, transform 0.2s',
          position: 'relative',
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          height: isMobile ? 'auto' : 160,
        }}
        onMouseEnter={e => { if (!l.isExample) { e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.08)'; } }}
        onMouseLeave={e => { e.currentTarget.style.boxShadow = 'none'; }}>

        {/* Image */}
        <div style={{ position: 'relative', width: isMobile ? '100%' : 220, height: isMobile ? 180 : '100%', flexShrink: 0, overflow: 'hidden', background: '#f0f0f0', borderRadius: isMobile ? '16px 16px 0 0' : '16px 0 0 16px' }}>
          {l.img ? (
            <img src={l.img} alt={l.title} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', transition: 'transform 0.3s' }}
              onMouseEnter={e => e.target.style.transform = 'scale(1.04)'}
              onMouseLeave={e => e.target.style.transform = 'scale(1)'}
              onError={e => { e.target.style.display = 'none'; }} />
          ) : (
            <div style={{ width: '100%', height: '100%', background: '#E8F5F0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#A7E3CD" strokeWidth="1.5"><path d="M3 21V9l9-6 9 6v12"/></svg>
            </div>
          )}
          {isReal && (
            <div style={{ position: 'absolute', top: 8, left: 8, background: '#1D9E75', color: '#fff', fontSize: 10, fontWeight: 600, padding: '3px 8px', borderRadius: 20, letterSpacing: '0.3px' }}>
              ✓ Havenly
            </div>
          )}
          {score && sc && (
            <div style={{ position: 'absolute', top: 8, left: isReal ? 76 : 8, background: sc.bg, color: sc.color, fontSize: 10, fontWeight: 600, padding: '3px 8px', borderRadius: 20, display: 'flex', alignItems: 'center', gap: 3 }}>
              <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
              {score}/100
            </div>
          )}
          <button onClick={e => { e.stopPropagation(); toggleFav(l.id); }}
            style={{ position: 'absolute', top: 8, right: 8, width: 28, height: 28, borderRadius: '50%', background: 'rgba(255,255,255,0.92)', border: 'none', cursor: 'pointer', fontSize: 14, color: isFav ? '#E24B4A' : 'var(--ink-3)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {isFav ? '♥' : '♡'}
          </button>
        </div>

        {/* Infos */}
<div style={{ flex: 1, padding: '14px 16px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', minWidth: 0 }}>
  <div>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8, marginBottom: 2 }}>
      <div style={{ fontSize: 11, color: 'var(--ink-4)' }}>{l.location || l.region}</div>
      {!l.isExample && l.reviews > 0 && (
        <div style={{ fontSize: 12, color: 'var(--ink-3)', flexShrink: 0, display: 'flex', alignItems: 'center', gap: 3 }}>
          <span style={{ color: '#F59E0B' }}>★</span> {l.rating} <span style={{ color: 'var(--ink-4)' }}>({l.reviews} avis)</span>
        </div>
      )}
    </div>
    <div style={{ fontSize: 14, fontWeight: 500, lineHeight: 1.35, marginBottom: 6, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{l.title}</div>

    {/* Cible + vidéo */}
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, marginBottom: 6 }}>
      {l.target_audience && l.target_audience.split(',').filter(Boolean).slice(0, 2).map((t, i) => (
        <span key={i} style={{ fontSize: 11, padding: '2px 8px', background: '#FDF8F4', color: '#C4784A', borderRadius: 20, fontWeight: 500 }}>
          🎯 {t.trim()}
        </span>
      ))}
      {l.video_url && (
        <span style={{ fontSize: 11, padding: '2px 8px', background: 'var(--green-light)', color: 'var(--green-mid)', borderRadius: 20, fontWeight: 500 }}>
          🎬 Vidéo disponible
        </span>
      )}
    </div>

    {!l.isExample && (
      <div style={{ fontSize: 12, color: 'var(--ink-3)' }}>
        {l.guests} pers. · {l.beds} ch. · {l.baths} sdb
      </div>
    )}
  </div>

  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 10, paddingTop: 10, borderTop: '0.5px solid var(--border)' }}>
    {l.isExample ? (
      <span style={{ fontSize: 11, color: 'var(--ink-4)', fontStyle: 'italic' }}>Disponible prochainement</span>
    ) : (
      <div style={{ display: 'flex', alignItems: 'center', gap: 4, background: 'var(--green-light)', padding: '3px 8px', borderRadius: 20 }}>
        <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="var(--green-mid)" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
        <span style={{ fontSize: 11, color: 'var(--green-mid)', fontWeight: 500 }}>Prix final · 0 € de frais Havenly</span>
      </div>
    )}
    <div style={{ textAlign: 'right' }}>
      <span style={{ fontSize: 12, color: 'var(--ink-3)', fontWeight: 400 }}>à partir de </span>
      <span style={{ fontSize: 16, fontWeight: 600 }}>{l.priceNight} €</span>
      <span style={{ fontSize: 12, color: 'var(--ink-3)', fontWeight: 400 }}> / nuit</span>
    </div>
  </div>
</div>
      </div>
    );
  };

  return (
    <div style={{ background: 'var(--surface)', minHeight: '100vh', paddingTop: 60 }}>

      {/* Barre de recherche */}
      <div style={{ background: 'var(--white)', borderBottom: '0.5px solid var(--border)', padding: isMobile ? '10px 1rem' : '12px 2rem' }}>
        <SearchBar onSearch={(city) => { onNavigate('search', city); }} compact />
      </div>

      {/* Barre filtres */}
      <div style={{ background: 'var(--white)', borderBottom: '0.5px solid var(--border)', padding: isMobile ? '10px 1rem' : '10px 2rem', display: 'flex', gap: 8, alignItems: 'center', overflowX: 'auto' }}>

        {/* Mobile — bouton filtres + toggle carte */}
        {isMobile && (
          <>
            <button onClick={() => setFiltersOpen(true)} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '6px 14px', borderRadius: 20, fontSize: 13, fontFamily: 'var(--sans)', cursor: 'pointer', border: `1px solid ${activeFiltersCount > 0 ? 'var(--green)' : 'var(--border)'}`, background: activeFiltersCount > 0 ? 'var(--green-light)' : 'var(--white)', color: activeFiltersCount > 0 ? 'var(--green-mid)' : 'var(--ink-3)', fontWeight: 500, flexShrink: 0 }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="4" y1="6" x2="20" y2="6"/><line x1="8" y1="12" x2="16" y2="12"/><line x1="11" y1="18" x2="13" y2="18"/></svg>
              Filtres {activeFiltersCount > 0 && <span style={{ background: 'var(--green)', color: '#fff', borderRadius: '50%', width: 16, height: 16, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 10 }}>{activeFiltersCount}</span>}
            </button>
            <button onClick={() => setMobileView(v => v === 'list' ? 'map' : 'list')}
              style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '6px 14px', borderRadius: 20, fontSize: 13, fontFamily: 'var(--sans)', cursor: 'pointer', border: `1px solid ${mobileView === 'map' ? 'var(--green)' : 'var(--border)'}`, background: mobileView === 'map' ? 'var(--green-light)' : 'var(--white)', color: mobileView === 'map' ? 'var(--green-mid)' : 'var(--ink-3)', fontWeight: 500, flexShrink: 0 }}>
              {mobileView === 'map' ? (
                <><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg> Liste</>
              ) : (
                <><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="3 11 22 2 13 21 11 13 3 11"/></svg> Carte</>
              )}
            </button>
          </>
        )}

        {/* Desktop — types + categories + toggle carte */}
        {!isMobile && (
          <>
            {FILTERS.map(f => (
              <button key={f} onClick={() => setActiveType(f)} style={{ padding: '6px 16px', borderRadius: 20, fontSize: 13, fontFamily: 'var(--sans)', cursor: 'pointer', border: `0.5px solid ${activeType === f ? 'var(--green)' : 'rgba(26,26,24,0.18)'}`, background: activeType === f ? 'var(--green-light)' : 'transparent', color: activeType === f ? 'var(--green-mid)' : 'var(--ink-3)', fontWeight: activeType === f ? 500 : 400, flexShrink: 0 }}>
                {f}
              </button>
            ))}
            <div style={{ width: 1, height: 20, background: 'var(--border)', margin: '0 4px', flexShrink: 0 }} />
            {CATEGORIES.map(cat => (
              <button key={cat.id} onClick={() => setActiveCategory(c => c === cat.id ? '' : cat.id)}
                style={{ padding: '6px 14px', borderRadius: 20, fontSize: 12, fontFamily: 'var(--sans)', cursor: 'pointer', border: `0.5px solid ${activeCategory === cat.id ? 'var(--green)' : 'rgba(26,26,24,0.18)'}`, background: activeCategory === cat.id ? 'var(--green-light)' : 'transparent', color: activeCategory === cat.id ? 'var(--green-mid)' : 'var(--ink-3)', fontWeight: activeCategory === cat.id ? 500 : 400, flexShrink: 0 }}>
                {cat.label}
              </button>
            ))}
            <div style={{ width: 1, height: 20, background: 'var(--border)', margin: '0 4px', flexShrink: 0 }} />
            {AMENITY_OPTIONS.slice(0, 3).map(a => (
              <button key={a} onClick={() => toggleAmenity(a)} style={{ padding: '6px 14px', borderRadius: 20, fontSize: 12, fontFamily: 'var(--sans)', cursor: 'pointer', border: `0.5px solid ${activeAmenities.includes(a) ? 'var(--green)' : 'rgba(26,26,24,0.18)'}`, background: activeAmenities.includes(a) ? 'var(--green-light)' : 'transparent', color: activeAmenities.includes(a) ? 'var(--green-mid)' : 'var(--ink-3)', fontWeight: activeAmenities.includes(a) ? 500 : 400, flexShrink: 0 }}>
                {a}
              </button>
            ))}
            <div style={{ marginLeft: 'auto', flexShrink: 0 }}>
              <button onClick={() => setShowMap(v => !v)}
                style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '6px 16px', borderRadius: 20, fontSize: 13, fontFamily: 'var(--sans)', cursor: 'pointer', border: `1px solid ${showMap ? 'var(--green)' : 'var(--border)'}`, background: showMap ? 'var(--green-light)' : 'var(--white)', color: showMap ? 'var(--green-mid)' : 'var(--ink-3)', fontWeight: 500 }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="3 11 22 2 13 21 11 13 3 11"/></svg>
                {showMap ? 'Masquer la carte' : 'Afficher la carte'}
              </button>
            </div>
          </>
        )}
      </div>

      {/* Modal filtres mobile */}
      {isMobile && filtersOpen && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 1000, display: 'flex', alignItems: 'flex-end' }}
          onClick={() => setFiltersOpen(false)}>
          <div style={{ background: 'var(--white)', borderRadius: '20px 20px 0 0', width: '100%', padding: '20px 20px 40px', maxHeight: '85vh', overflowY: 'auto', position: 'relative', zIndex: 2000 }}
            onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <h3 style={{ fontFamily: 'var(--serif)', fontSize: 18 }}>Filtres</h3>
              <button onClick={() => setFiltersOpen(false)} style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: 'var(--ink-3)' }}>×</button>
            </div>
            <FilterPanel />
            <button onClick={() => setFiltersOpen(false)} style={{ width: '100%', padding: '13px', background: 'var(--green)', color: '#fff', border: 'none', borderRadius: 12, fontSize: 15, fontWeight: 500, cursor: 'pointer', fontFamily: 'var(--sans)', marginTop: 20 }}>
              Voir {results.length} logement{results.length !== 1 ? 's' : ''}
            </button>
          </div>
        </div>
      )}

      {/* ── CONTENU PRINCIPAL ── */}
      {isMobile ? (
        // ── MOBILE ──────────────────────────────────────────────────────────
        <div style={{ padding: '1rem' }}>
          {mobileView === 'map' ? (
            // Vue carte mobile
            <div style={{ position: 'relative', height: 'calc(100vh - 180px)', borderRadius: 12, overflow: 'hidden' }}>
              <MapView
                listings={results}
                onSelectListing={l => setSelectedListing(l)}
                selectedId={selectedListing?.id}
              />
              {selectedListing && (
                <MapPopup
                  listing={selectedListing}
                  onClose={() => setSelectedListing(null)}
                  onNavigate={onNavigate}
                />
              )}
            </div>
          ) : (
            // Vue liste mobile
            <div>
              {/* Bandeau filtre actif */}
              {effectiveFilter && (
                <div style={{ background: '#EEEDFE', border: '1px solid #AFA9EC', borderRadius: 10, padding: '10px 16px', marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
                  <span style={{ fontSize: 13, color: '#534AB7' }}><strong style={{ fontWeight: 500 }}>Emma</strong> — Résultats pour "{effectiveFilter}"</span>
                  <button onClick={() => { localStorage.removeItem('havenly_search_location'); onNavigate('search'); }} style={{ background: 'none', border: 'none', fontSize: 12, color: '#534AB7', cursor: 'pointer', textDecoration: 'underline' }}>Voir tous</button>
                </div>
              )}
              
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                <div style={{ fontSize: 13, color: 'var(--ink-3)' }}>
                  {realLoading ? <span style={{ color: 'var(--ink-4)' }}>Chargement...</span> : <><strong style={{ color: 'var(--ink)', fontWeight: 500 }}>{results.length} logement{results.length > 1 ? 's' : ''}</strong></>}
                </div>
                <select value={sortBy} onChange={e => setSortBy(e.target.value)} style={{ fontSize: 13, border: '0.5px solid rgba(26,26,24,0.18)', borderRadius: 8, padding: '6px 12px', background: 'var(--white)', color: 'var(--ink-3)', fontFamily: 'var(--sans)', cursor: 'pointer' }}>
                  <option value="default">Meilleur rapport</option>
                  <option value="price_asc">Prix croissant</option>
                  <option value="rating">Mieux notés</option>
                </select>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {results.map(l => <ListingCard key={l.id} l={l} />)}
              </div>
              {results.length === 0 && !realLoading && (
                <div style={{ textAlign: 'center', padding: '4rem 1rem' }}>
                  <div style={{ fontSize: 40, marginBottom: 14 }}>🔍</div>
                  <h3 style={{ fontFamily: 'var(--serif)', fontSize: 20, marginBottom: 8 }}>Aucun logement trouvé</h3>
                  <p style={{ fontSize: 14, color: 'var(--ink-3)', marginBottom: 20 }}>Essayez une autre destination ou élargissez vos critères.</p>
                  <button onClick={() => { localStorage.removeItem('havenly_search_location'); setActiveCategory(''); setActiveType('Tout'); onNavigate('search'); }}
                    style={{ padding: '10px 24px', background: 'var(--green)', color: '#fff', border: 'none', borderRadius: 20, fontSize: 14, cursor: 'pointer', fontFamily: 'var(--sans)' }}>
                    Voir tous les logements
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      ) : (
        // ── DESKTOP — split liste + carte ───────────────────────────────────
        <div style={{ display: 'flex', height: 'calc(100vh - 130px)', overflow: 'hidden' }}>

          {/* Colonne liste */}
          <div style={{ width: showMap ? '50%' : '100%', overflowY: 'auto', padding: '1.5rem 2rem', transition: 'width 0.3s ease' }}>

            {effectiveFilter && (
              <div style={{ background: '#EEEDFE', border: '1px solid #AFA9EC', borderRadius: 10, padding: '10px 16px', marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
                <span style={{ fontSize: 13, color: '#534AB7' }}><strong style={{ fontWeight: 500 }}>Emma</strong> — Résultats pour "{effectiveFilter}"</span>
                <button onClick={() => { localStorage.removeItem('havenly_search_location'); onNavigate('search'); }} style={{ background: 'none', border: 'none', fontSize: 12, color: '#534AB7', cursor: 'pointer', textDecoration: 'underline' }}>Voir tous les logements</button>
              </div>
            )}

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, flexWrap: 'wrap', gap: 10 }}>
              <div style={{ fontSize: 14, color: 'var(--ink-3)' }}>
                {realLoading ? (
                  <span style={{ color: 'var(--ink-4)' }}>Chargement des logements...</span>
                ) : (
                  <><strong style={{ color: 'var(--ink)', fontWeight: 500 }}>{results.length} logement{results.length > 1 ? 's' : ''}</strong> — prix total affiché, sans surprise</>
                )}
              </div>
              <select value={sortBy} onChange={e => setSortBy(e.target.value)} style={{ fontSize: 13, border: '0.5px solid rgba(26,26,24,0.18)', borderRadius: 8, padding: '6px 12px', background: 'var(--white)', color: 'var(--ink-3)', fontFamily: 'var(--sans)', cursor: 'pointer' }}>
                <option value="default">Meilleur rapport</option>
                <option value="price_asc">Prix croissant</option>
                <option value="rating">Mieux notés</option>
              </select>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 16 }}>
              {results.map(l => <ListingCard key={l.id} l={l} />)}
            </div>

            {effectiveFilter && results.length > 0 && nearby && (
              <div style={{ marginTop: 24, padding: '20px 24px', background: 'var(--white)', border: '1px solid var(--border)', borderRadius: 14 }}>
                <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 10 }}>📍 Autres destinations à proximité</div>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  {nearby.map(dest => (
                    <button key={dest} onClick={() => onNavigate('search', dest)}
                      style={{ padding: '6px 14px', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 20, fontSize: 12, cursor: 'pointer', fontFamily: 'var(--sans)', color: 'var(--ink-3)' }}>
                      {dest} →
                    </button>
                  ))}
                </div>
              </div>
            )}

            {results.length === 0 && !realLoading && (
              <div style={{ textAlign: 'center', padding: '4rem 1rem' }}>
                <div style={{ fontSize: 40, marginBottom: 14 }}>🔍</div>
                <h3 style={{ fontFamily: 'var(--serif)', fontSize: 20, marginBottom: 8 }}>Aucun logement trouvé</h3>
                <p style={{ fontSize: 14, color: 'var(--ink-3)', marginBottom: 20 }}>Essayez une autre destination ou élargissez vos critères.</p>
                <button onClick={() => { localStorage.removeItem('havenly_search_location'); setActiveCategory(''); setActiveType('Tout'); onNavigate('search'); }}
                  style={{ padding: '10px 24px', background: 'var(--green)', color: '#fff', border: 'none', borderRadius: 20, fontSize: 14, cursor: 'pointer', fontFamily: 'var(--sans)' }}>
                  Voir tous les logements
                </button>
              </div>
            )}
          </div>

          {/* Colonne carte */}
          {showMap && (
            <div style={{ width: '50%', position: 'sticky', top: 0, height: 'calc(100vh - 130px)', padding: '1rem 1rem 1rem 0', flexShrink: 0 }}>
              <div style={{ position: 'relative', width: '100%', height: '100%', borderRadius: 16, overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
                <MapView
                  listings={results}
                  onSelectListing={l => setSelectedListing(l)}
                  selectedId={selectedListing?.id}
                />
                {selectedListing && (
                  <MapPopup
                    listing={selectedListing}
                    onClose={() => setSelectedListing(null)}
                    onNavigate={onNavigate}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
